import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

const LikesRow = ({ likes, dislikes, question, isCertified }) => (
  <div className="mars--challenges__info--item">
    <div className="icons success">
      <span>{likes}</span>
      <span className="icon-like"> </span>
    </div>
    <div className="icons failed">
      <span>{dislikes}</span>
      <span className="icon-dislike"> </span>
    </div>
    <span className="text text--ellipsis">{question}</span>
    {isCertified && (
      <span className="result success">
        <div className="icons success">
          <span className="icon-badge"> </span>
          <span className="text">
            <FormattedMessage id="phase.tooltips.certified" />
          </span>
        </div>
      </span>
    )}
  </div>
)

LikesRow.propTypes = {
  likes: PropTypes.number,
  dislikes: PropTypes.number,
  question: PropTypes.string,
  isCertified: PropTypes.bool,
}

const MineLikesTab = ({ ownQuestions }) => (
  <React.Fragment>
    {ownQuestions.length > 0 ? (
      ownQuestions.map(({ id, likes, dislikes, question, status }) => (
        <LikesRow
          key={id}
          likes={likes}
          dislikes={dislikes}
          question={question}
          isCertified={status === 'CERTIFIED'}
        />
      ))
    ) : (
      <div>
        <span className="text">
          <FormattedMessage id="phase.informationPhase_No_Likes" />
        </span>
      </div>
    )}
  </React.Fragment>
)

MineLikesTab.propTypes = {
  ownQuestions: PropTypes.array,
}

export default injectIntl(MineLikesTab)
